module.exports = "/packs/011-fca00e90fd4e8b05437fdecf8a4b96df.jpg";